(() => {
  const HeaderDropdown = class extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.addEventListener('pointerenter', () => {
        this.setAttribute('aria-expanded', 'true');

        if (this.headerOverlay !== null) {
          this.headerOverlay.classList.add('is-active');
          this.headerOverlay
            .querySelector('.header-overlay__inner')
            .classList.add('is-visible');
        }
      });
      this.addEventListener('pointerleave', () => {
        this.setAttribute('aria-expanded', 'false');

        if (this.headerOverlay !== null) {
          this.headerOverlay.classList.remove('is-active');
          this.headerOverlay
            .querySelector('.header-overlay__inner')
            .classList.add('is-visible');
        }
      });
    }

    get headerOverlay() {
      return document.querySelector('[data-header-overlay]');
    }
  };
  if (!window.customElements.get('header-dropdown')) {
    window.customElements.define('header-dropdown', HeaderDropdown);
  }
})();
